import React, { useEffect, useRef, useState } from 'react';
import { Loader2, Mic, Pause, Play } from 'lucide-react';
import { toast } from 'sonner';
import { useVoiceovers } from './VoiceoverContext';

export const ClipPlayer = ({ refId }) => {
  const { items, busy, generate, audioUrl, claim } = useVoiceovers();
  const [playing, setPlaying] = useState(false);
  const audio = useRef(null);
  useEffect(() => () => audio.current?.pause(), []);
  const has = !!items[refId];

  const toggle = async () => {
    if (playing) { audio.current?.pause(); setPlaying(false); return; }
    try {
      if (!has) await generate(refId);
      const a = new Audio(await audioUrl(refId));
      audio.current?.pause();
      audio.current = a;
      a.onended = () => setPlaying(false);
      claim(() => { a.pause(); setPlaying(false); });
      await a.play();
      setPlaying(true);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not play the voice-over');
    }
  };
  const regen = async () => {
    try { await generate(refId); toast.success('Voice-over ready'); } catch (e) { toast.error('Voice generation failed'); }
  };

  return (
    <div className="sc-clip" data-testid={`clip-${refId}`}>
      <button type="button" className="sc-clip-btn" onClick={toggle} disabled={busy[refId]} data-testid={`clip-play-${refId}`}>
        {busy[refId] ? <Loader2 size={14} className="animate-spin" /> : playing ? <Pause size={14} /> : <Play size={14} />}
        {busy[refId] ? 'Creating voice-over…' : playing ? 'Pause' : has ? 'Play voice-over' : 'Create & play voice-over'}
      </button>
      {has && !busy[refId] && (
        <button type="button" className="sc-clip-link" onClick={regen} data-testid={`clip-status-${refId}`} title="Already created — click to check for script changes">
          <Mic size={12} /> {items[refId].file_name}
        </button>
      )}
    </div>
  );
};
